module.exports = __webpack_public_path__ + "img/fabulous5.122a5876.svg";